<template>
  <v-hover v-slot="{ hover }">
    <v-text-field class="q-input" :class="[BorderClass, CompactClass, BlurrClass, InputColorClass, 'removeunderline']"
      :background-color="BackgroundColor" :label="labelText" :value="''" :readonly="true" hide-details="auto"
      :single-line="singleline" :hoverbool="setHoverBool(hover)" :color="color" :rules="rules || []" :counter="false"
      :messages="[]" flat>
      <!-- PREPEND SLOTS -->
      <template v-slot:prepend>
        <slot name="prepend" />
      </template>

      <!-- APPEND CONTROL -->
      <template v-slot:append>
        <div class="d-flex align-center" style="min-width: 220px;">
          <v-slider class="q-slider ma-0 pa-0" :min="0" :max="steps.length - 1" :step="1" :tick-size="2" ticks="always"
            :tick-labels="tickLabels" :value="currentIndex" :disabled="IsDisabled || disabled" :loading="loading"
            @input="onIndexInput" @change="onIndexChange" />
          <span class="ml-2 text-caption">{{ displayText }}</span>
        </div>
        <ExternalChangeWarning v-if="externallychanged" @Sync="(newValue = value, externallychanged = false)" />
      </template>

      <template v-slot:append-outer>
        <slot name="append-outer" />
      </template>
    </v-text-field>
  </v-hover>
</template>


<script>
import InputMixin from "@/helpers/Mixins/InputMixin";
import ExternalChangeWarning from "@/components/Inputs/Parts/ExternalChangeWarning.vue";

export default {
  name: "MintesOfHourSlider",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    value: Number, // minutes
    singleline: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    emitOnlyOnBlur: Boolean,
    rules: Array,
    color: String,
  },
  components: {
    ExternalChangeWarning,
  },
  mixins: [InputMixin],

  data() {
    return {
      steps: [0, 1, 5, 10, 15, 20, 30, 60],
      newValue: this.normalizeValue(this.value),
      edit: false,
    };
  },

  methods: {
    normalizeValue(v) {
      const num = typeof v === "number" ? v : parseInt(v, 10) || 0;
      // Snap to nearest allowed step
      let nearest = this.steps[0];
      let minDelta = Math.abs(num - nearest);
      for (const s of this.steps) {
        const d = Math.abs(num - s);
        if (d < minDelta) {
          nearest = s;
          minDelta = d;
        }
      }
      return nearest;
    },
    onIndexInput(idx) {
      this.setEdit();
      const val = this.steps[idx] ?? 0;
      this.newValue = val;
      // emit live updates to mirror other inputs behavior
      this.$emit("input", this.newValue);
    },
    onIndexChange(idx) {
      const val = this.steps[idx] ?? 0;
      this.newValue = val;
      this.blurInput();
    },
  },

  computed: {
    currentIndex() {
      const i = this.steps.indexOf(this.normalizeValue(this.newValue));
      return i >= 0 ? i : 0;
    },
    tickLabels() {
      return this.steps.map((m) => (m === 0 ? "0" : String(m)));
    },
    displayText() {
      const m = this.normalizeValue(this.newValue);
      return m === 0 ? this.$t("servicesystem.common_objects.commonterms.no_rounding") : `${m} min`;
    },
  },

  watch: {
    value(val) {
      this.newValue = this.normalizeValue(val);
    },
  },
};
</script>


<style scoped>
</style>